/** 
 * Get the name of a measure in its requested language.
 * @param {Object} measure The measure to derive the name from
 * @param {String} locale Locale id string
 * 
 * @returns {String} Translated measure name, default to 'nl' name.
 */
export function getMeasureName(measure, locale) {
    return measure.name;
}